export function formatDate(dateString: string | null) {
	if (!dateString) return "";
	return dateString.split("T")[0]; // Pega só a parte da data
}
